/* src/app/system-utils/form-array-component/form-array-component.component.scss */
.array-box {
  display: flex;
  height: 100%;
  flex-direction: column;
  border-radius: var(--tem-radius);
  border: 1px solid var(--tem-border);
  background: var(--tem-surface);
  padding: 10px;
  margin-top: 10px;
  margin-bottom: 10px;
  overflow: auto;
  font-family: var(--tem-font-family);
}
.tool-field {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.title-field {
  color: var(--tem-ink);
}
.spacer {
  flex: 1;
}
.full {
  width: 100%;
}
.display-array {
  padding-top: 6px;
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  overflow: auto;
}
.form-array {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
}
.display-formgroup {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  overflow: auto;
  border-top: 1px solid var(--tem-border);
}
.display-filegroup-item {
  display: flex;
  flex-direction: row;
  height: 100%;
  width: 100%;
  padding-right: 10px;
  padding-top: 10px;
  padding-left: 10px;
  padding-bottom: 6px;
  overflow: auto;
}
.display-filegroup-item.selected {
  margin-top: 6px;
  padding-bottom: 6px;
  border-radius: var(--tem-radius);
  border: 1px solid var(--tem-border);
  background: var(--tem-surface-2);
}
.space {
  padding-left: 10px;
}
.display-formgroup:hover {
  cursor: pointer;
}
.display-filegroup-item-components {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 10px;
  overflow: auto;
  padding-right: 10px;
  padding-top: 10px;
}
.display-filegroup-item-components-lines {
  display: flex;
  flex-direction: column;
  width: 100%;
}
.suffix-icon {
  cursor: pointer;
  color: var(--tem-muted);
}
.suffix-icon:hover {
  color: var(--tem-ink);
}
.toggle-line {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  color: var(--tem-ink);
}
.itens-remove {
  align-self: center;
}
:host {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: auto;
}
.action-buttons {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding-left: 10px;
  gap: 10px;
  align-items: flex-end;
  justify-content: center;
  border-left: 1px solid var(--tem-border);
}
/*# sourceMappingURL=form-array-component.component.css.map */
